import { combineReducers } from "redux";
import getQuickSightDashboardReducer from "features/quickSightDashboard/slices/quickSightDashboard.slice";
import getGuestUserSessionsReducer from "features/adminDashboard/slices/guestUserSessions.slice";
import getSubscribedUserSessionsReducer from "features/adminDashboard/slices/subscribedUserSessions.slice";
import getGuestUserReportsReducer from "features/adminDashboard/slices/revenueReports.slice";
import signUpReducer from "features/authDashboard/slices/signUp.slice";
import signInReducer from "features/authDashboard/slices/signIn.slice";
import resetPassword from "features/authDashboard/slices/resetPassword.slice";
import getSubscribedUSersPaidReportsReducer from "features/adminDashboard/slices/subscribedUserPaidReports.slice";
import getMonthlyDataReducer from "features/adminDashboard/slices/monthlyData.slice";
import getSubscribedUsersReducer from "features/adminDashboard/slices/subscribedUsers.slice";
import getMetricsReducer from "features/adminDashboard/slices/updateMetrics.slice";
import getAdminUsersReducer from "features/adminUserManagement/slice/getUsers.slice";
import deleteUserReducer from "features/adminUserManagement/slice/deleteUser.slice";
import createNewUserReducer from "features/adminUserManagement/slice/createNewUser.slice";
import updateUserReducer from "features/adminUserManagement/slice/updateUser.slice";
import getUserAuditLogsReducer from "features/adminUserManagement/slice/getUserAuditLogs.slice";
import getUsersDetailsFromEmailReducer from "features/adminUserManagement/slice/getUserDetailsFromEmail.slice";
import getRevenueReducer from "features/adminDashboard/slices/revenueReports.slice";
import getPurchaseReducer from "features/adminDashboard/slices/purchaseData.slice";
import getTrasactionsDataReducer from "features/adminDashboard/slices/transactionsData.slice";
import getDashboardSessionCountReducer from "features/adminDashboard/slices/dashboardSessionCount.slice";
import getPricingFiltersStatesReducer from "features/pricing/slices/pricingFiltersStates.slice";
import getStatesReducer from "features/pricing/slices/pricingFiltersStates.slice";
import savePurchaseSelectionReducer from "features/pricing/slices/savePurchaseSelection";
import pricingRegionsHospitals from "features/pricing/slices/pricingRegionsHospitals";
import saveRegionHospitalMasterData from "features/pricing/slices/regionsAndHospital.slice";
import deviceDetection from "../slices/deviceDetection.slice";
import getStripePublishKeyReducer from "features/stripPayment/slices/getPublishKey.slice";
import getStripeClientSecretReducer from "features/stripPayment/slices/getClientSecrets.slice";
import userTransactionSlice from "features/stripPayment/slices/userTransaction.slice";
import saveStatePageNumberLimitSlice from "features/pricing/slices/statesPageNumber.slice";
import saveRegionsHospitalsLimit from "features/pricing/slices/regionHospitalPageNumber.slice";
import postUserTransactionDataSlice from "features/stripPayment/slices/postTransaction.slice";
import getPlansOptionsReducer from "features/pricing/slices/getPlans.slice";
import getPricingPreviewReducer from "features/pricing/slices/pricingPreview.slice";
import paymentStatusReducer from "features/stripPayment/slices/paymentStatus.slice";
import generatePurchaseDatasetReducer from "features/stripPayment/slices/generatePurchaseDataset.slice";
import getGeneratedDataSetReducer from "features/stripPayment/slices/getGeneratedDataSetURL.slice";
import getPurchasePreviewTableDAta from "features/pricing/slices/pricingPreview.slice";
import getTransactionLogsReducer from "features/transactionLogs/slices/getTransactionLogs.slice";
import getStatesDropdownReducer from "features/transactionLogs/slices/getStates.slice";
import quickSightTimerReducer from "features/quickSightDashboard/slices/quickSightTimer.slice";
import createUserDashboardSessionsReducer from "features/quickSightDashboard/slices/createUserDashboardSessions.slice";
import resendDatasetEmailReducer from "features/transactionLogs/slices/resendDataSet.slice";
import saveTransactionLogsSearchFilterReducer from "features/transactionLogs/slices/transactionLogsSearchFilters.slice";
import adminDashboardTimeRangeReducer from "features/adminDashboard/slices/updateTimeRangeSelection.slice";
import adminDashboardTimeSelectionReducer from "features/adminDashboard/slices/saveTimeDropdownSelection.slice";
import getSpecificTransactionLogReducer from "features/transactionLogs/slices/getSpecificTransactionLog.slice";
import saveSelectAllFromPricingFiltersReducer from "features/pricing/slices/pricingFiltersSelectAll.slice";
import masterDatasetReducer from "features/adminDashboard/slices/masterDataset.slice";
import masterCardsDataReducer from "features/adminDashboard/slices/saveMasterDataForCards.slice";

const rootReducer = combineReducers({
  quickSightTimer: quickSightTimerReducer,
  getGuestUserSessions: getGuestUserSessionsReducer,
  getSubscribedUserSessions: getSubscribedUserSessionsReducer,
  getQuickSightDashboard: getQuickSightDashboardReducer,
  getGuestUserPaidReports: getGuestUserReportsReducer,
  getSubscribedUsersPaidReports: getSubscribedUSersPaidReportsReducer,
  getMonthlyDataReducer: getMonthlyDataReducer,
  getSubscribedUsersReducer: getSubscribedUsersReducer,
  getMetricsReducer: getMetricsReducer,
  signIn: signInReducer,
  signUp: signUpReducer,
  resetPassword: resetPassword,
  getAdminUsersReducer: getAdminUsersReducer,
  deleteUserReducer: deleteUserReducer,
  createNewUserReducer: createNewUserReducer,
  updateUserReducer: updateUserReducer,
  getUserAuditLogsReducer: getUserAuditLogsReducer,
  getUsersDetailsFromEmailReducer: getUsersDetailsFromEmailReducer,
  getRevenueReducer: getRevenueReducer,
  getPurchaseReducer: getPurchaseReducer,
  getTrasactionsDataReducer: getTrasactionsDataReducer,
  getDashboardSessionCountReducer: getDashboardSessionCountReducer,
  getPricingFiltersStatesReducer: getPricingFiltersStatesReducer,
  savePurchaseSelectionReducer: savePurchaseSelectionReducer,
  getStatesReducer: getStatesReducer,
  pricingRegionsHospitals: pricingRegionsHospitals,
  saveRegionsHospitalSelectionMasterDAta: saveRegionHospitalMasterData,
  deviceDetection: deviceDetection,
  getStripePublishKeyReducer: getStripePublishKeyReducer,
  getStripeClientSecretReducer: getStripeClientSecretReducer,
  saveUserTransaction: userTransactionSlice,
  saveStatePageNumberLimitSlice: saveStatePageNumberLimitSlice,
  saveRegionsHospitalsLimit: saveRegionsHospitalsLimit,
  postUserTransactionDataSlice: postUserTransactionDataSlice,
  getPlansOptionsReducer: getPlansOptionsReducer,
  getPricingPreviewReducer: getPricingPreviewReducer,
  paymentStatusReducer: paymentStatusReducer,
  generatePurchaseDatasetReducer: generatePurchaseDatasetReducer,
  getGeneratedDataSetReducer: getGeneratedDataSetReducer,
  getPurchasePreviewTableDAta: getPurchasePreviewTableDAta,
  getTransactionLogsReducer: getTransactionLogsReducer,
  getStatesDropdownReducer: getStatesDropdownReducer,
  createUserDashboardSessionsReducer: createUserDashboardSessionsReducer,
  resendDatasetEmailReducer: resendDatasetEmailReducer,
  saveTransactionLogsSearchFilterReducer: saveTransactionLogsSearchFilterReducer,
  adminDashboardTimeRangeReducer: adminDashboardTimeRangeReducer,
  adminDashboardTimeSelectionReducer: adminDashboardTimeSelectionReducer,
  getSpecificTransactionLogReducer: getSpecificTransactionLogReducer,
  saveSelectAllFromPricingFiltersReducer: saveSelectAllFromPricingFiltersReducer,
  masterDatasetReducer: masterDatasetReducer,
  masterCardsDataReducer: masterCardsDataReducer,
});

export default rootReducer;
